import styled from 'styled-components';

const JobDetails = styled.div`
  .screen-caption {
    display: flex;
    align-items: center;
    margin-top: 0.8em;
    margin-bottom: 1.7em;
  }
  .screen-title {
    font-size: 2.25em;
    margin-left: 0.5em;
  }
`;


export default {
  JobDetails
};